// src/services/FAQServices.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  FAQ_LIST,
  FAQ_ADD,
  FAQ_UPDATE,
  FAQ_DELETE,
} from "../../config/constants"; // Adjust endpoints as per your config

const FAQServices = createApi({
  reducerPath: "FAQServices",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["FAQ"],
  endpoints: (builder) => ({
    getFAQs: builder.query({
      query: (bodyData) => ({
        url: FAQ_LIST, // Endpoint to fetch ingredient list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["FAQ"],
    }),
    addFAQ: builder.mutation({
      query: (ingredientData) => ({
        url: FAQ_ADD, // Endpoint to add a ingredient
        method: "POST",
        data: ingredientData, // FAQ data for the request body
      }),
      invalidatesTags: ["FAQ"],
    }),
    updateFAQ: builder.mutation({
      query: ({ ingredientId, updatedData }) => ({
        url: `${FAQ_UPDATE}/${ingredientId}`, // Endpoint to update a ingredient
        method: "PUT",
        data: updatedData, // Updated ingredient data
      }),
      invalidatesTags: ["FAQ"],
    }),
    deleteFAQ: builder.mutation({
      query: (ingredientId) => ({
        url: `${FAQ_DELETE}/${ingredientId}`, // Endpoint to delete a ingredient
        method: "DELETE",
      }),
      invalidatesTags: ["FAQ"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetFAQsQuery,
  useAddFAQMutation,
  useUpdateFAQMutation,
  useDeleteFAQMutation,
} = FAQServices;

// Export the reducer to be included in the store
export default FAQServices;
